module.exports = __webpack_public_path__ + "img/0xa898bbb508c04be26af3d319b7775927afcb02af.7cb4cf95.png";